import React, { useCallback, Fragment, createElement } from 'react';
import htmlParser from 'react-html-parser';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var HtmlMapper = function HtmlMapper(_ref) {
  var tagMap = _ref.children,
      html = _ref.html,
      acceptUnknown = _ref.acceptUnknown,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "html", "acceptUnknown"]);

  var render = useCallback(function (name, props, index, children) {
    if (!name) {
      return React.createElement(Fragment, {
        key: index
      }, children);
    } // TODO: can't find out why the type assert is needed, it _should_ work as-is.


    var Renderer = tagMap[name];

    var defaultRenderer = function defaultRenderer() {
      return createElement(name, _extends({}, props, {
        children: children,
        key: index
      }));
    }; // renderer was specified, but with null, meaning we can safely render this.


    if (Renderer === null) {
      return defaultRenderer();
    } // no renderer was specified


    if (typeof Renderer === 'undefined') {
      return acceptUnknown ? defaultRenderer() : null;
    }

    return React.createElement(Renderer, Object.assign({}, props, {
      index: index,
      key: index
    }), children);
  }, [acceptUnknown, tagMap]);
  var transform = useCallback(function (node, index) {
    var _node$children;

    var name = node.name;
    var children = null;

    switch (node.type) {
      case 'text':
        children = node.data;
        break;

      case 'tag':
        children = (_node$children = node.children) == null ? void 0 : _node$children.map(function (childNode, i) {
          return transform(childNode, i);
        });
        break;
    }

    return render(name, node.attribs, index, children);
  }, [render]);
  return React.createElement(React.Fragment, null, htmlParser(html, _extends({
    transform: transform
  }, rest)));
};

export default HtmlMapper;
//# sourceMappingURL=react-html-map.esm.js.map
